import React from 'react'
import { titleContent } from '../../Styles'

export default function VajrastraIntro() {
  return (
    <div className={`product_bg p-10 text-white ${titleContent}`}>VAJRASTRA V2</div>
  )
}
